import { useFirebase } from 'components/Firebase/index.js';
import { useQuery } from 'react-query';
import { CLIENT_PERMISSIONS, READ } from 'shared-permissions';
import useClientPermissions from './useClientPermissions.js';
const { EDIT_USERS_CLIENT } = CLIENT_PERMISSIONS;

const useClientUser = (clientId, userId, options = {}) => {
  const firebase = useFirebase();
  const { hasClientPermission } = useClientPermissions({ clientId });
  const hasReadPermission = hasClientPermission(EDIT_USERS_CLIENT, READ);

  const { enabled = true, ...rest } = options;

  return useQuery({
    queryKey: [`/clients/${clientId}/users/${userId}`],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const response = await agent.get(`/clients/${encodeURIComponent(clientId)}/users/${encodeURIComponent(userId)}`);
      return response?.body;
    },
    enabled: !!(enabled && clientId && userId && hasReadPermission),
    ...rest,
  });
};

export default useClientUser;
